export default __webpack_public_path__ + "static/media/research4.64408efa.jpg";